// extracted by css-extract-rspack-plugin
export default {"alertTitle":"SecurityAlert-module__alertTitle__F8KTY"};